// removed by extract-text-webpack-plugin
module.exports = {"cont":"Modal__cont___1OBqv","screen":"Modal__screen___1CngG","closeButton":"Modal__closeButton___zFuiD"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Modal/Modal.css
// module id = 746
// module chunks = 0